import { PlayerStatusEnum } from 'domain/event/PlayerStatusEnum';
import { PlayerTeamInvitationTypeEnum } from 'domain/event/PlayerTeamInvitationTypeEnum';
import { InvitationLink } from 'domain/invitationLink/InvitationLink';
import { UserProfilView } from 'domain/user/UserProfilView';

import { Team } from '../team/Team';
import { PlayerRoleEnum } from './PlayerRoleEnum';

export type PlayerStatus = 'ACCEPTED' | 'DECLINED' | 'PENDING';

export class PlayerTeam {
  constructor(
    public readonly id: number,
    public readonly team: Team | null,
    public readonly player: UserProfilView | null,
    public readonly role: PlayerRoleEnum,
    public readonly status: PlayerStatusEnum,
    public readonly invitationLink: InvitationLink | null,
    public readonly typeInvitation: PlayerTeamInvitationTypeEnum,
  ) {}
}
